import * as userInfoDetails from 'actions/userInfoDetails';
import * as devices from 'actions/devices';

import { HTTP_STATUS_CODES } from 'xm-constants/httpStatusCodes';

import { getParameterByName } from '@xmatters/common/utils/string';

import { scrollAndLoadHelper } from '../reducerUtils';

const BASE_10 = 10;

export default function userInfoDetailsReducer(state = {}, action) {
  const { type, userUuid, payload } = action;
  switch (type) {
    case userInfoDetails.LOAD_RECIPIENT_START:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          recipientInfo: {
            status: 'LOADING',
          },
        },
      };
    case userInfoDetails.LOAD_RECIPIENT_SUCCESS: {
      // If site is not visible, then the client only has USE-ONLY access
      const access = payload.site ? 'LOADED' : 'USE-ONLY';
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          recipientInfo: {
            payload,
            status: access,
          },
        },
      };
    }
    case userInfoDetails.LOAD_RECIPIENT_FAIL: {
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          recipientInfo: {
            status: 'FAILED',
          },
        },
      };
    }
    case devices.LOAD_USER_DEVICES_START:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          devicesInfo: {
            status: 'LOADING',
          },
        },
      };
    case devices.LOAD_USER_DEVICES_SUCCESS:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          devicesInfo: {
            payload,
            status: 'LOADED',
          },
        },
      };
    case devices.LOAD_USER_DEVICES_FAIL:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          devicesInfo: {
            status:
              payload.code === HTTP_STATUS_CODES.FORBIDDEN
                ? 'LOADED'
                : 'FAILED',
          },
        },
      };
    case userInfoDetails.LOAD_GROUPS_START:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          groupMembershipsInfo: {
            status: 'LOADING',
          },
        },
      };
    case userInfoDetails.LOAD_GROUPS_SUCCESS:
    case userInfoDetails.LOAD_MORE_GROUPS_SUCCESS: {
      const offset = parseInt(
        getParameterByName('offset', payload.links.self),
        BASE_10,
      );
      // Handled uninitialized cases
      const currentGroupsList = !state[userUuid]
        ? []
        : state[userUuid].groupMembershipsInfo.groups;
      const newGroupsList = scrollAndLoadHelper(
        offset,
        currentGroupsList,
        payload,
      );
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          groupMembershipsInfo: {
            groups: newGroupsList,
            totalGroups: payload.total,
            status: 'LOADED',
          },
        },
      };
    }
    case userInfoDetails.LOAD_GROUPS_FAIL:
      return {
        ...state,
        [userUuid]: {
          ...state[userUuid],
          groupMembershipsInfo: {
            status:
              payload.code === HTTP_STATUS_CODES.FORBIDDEN
                ? 'FORBIDDEN'
                : 'FAILED',
          },
        },
      };
    default:
      return state;
  }
}
